import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
export function StreamingVideo({ stream, ...props }) {
    const videoRef = useRef(null);
    useEffect(() => {
        const video = videoRef.current;
        if (!video)
            return;
        if (stream) {
            video.srcObject = stream;
            video.play().catch(() => { });
        }
        else {
            video.srcObject = null;
        }
    }, [stream]);
    return (_jsx("video", { ref: videoRef, autoPlay: true, playsInline: true, muted: true, ...props }));
}
